import app from 'flarum/forum/app';
import Button from 'flarum/common/components/Button';
import Form from 'flarum/common/components/Form';
import FormModal from 'flarum/common/components/FormModal';
import extractText from 'flarum/common/utils/extractText';
import Stream from 'flarum/common/utils/Stream';
export default class PhoneVerificationModal extends FormModal {
  challengeId = null;
  maskedPhone = null;
  oninit(vnode) {
    super.oninit(vnode);
    this.phone = Stream('');
    this.region = Stream('BE');
    this.code = Stream('');
  }
  className() {
    return 'PhoneVerificationModal Modal--small';
  }
  title() {
    return app.translator.trans('aooci-phone-verification.forum.modal.title');
  }
  content() {
    return m("div", {
      className: "Modal-body"
    }, m(Form, {
      className: "Form--centered"
    }, this.challengeId ? this.codeStep() : this.phoneStep()));
  }
  phoneStep() {
    return [m("p", {
      className: "helpText"
    }, app.translator.trans('aooci-phone-verification.forum.modal.phone_help')), m("div", {
      className: "Form-group PhoneVerificationModal-number"
    }, m("select", {
      className: "FormControl",
      bidi: this.region,
      "aria-label": extractText(app.translator.trans('aooci-phone-verification.forum.modal.region'))
    }, m("option", {
      value: "BE"
    }, "BE +32"), m("option", {
      value: "FR"
    }, "FR +33"), m("option", {
      value: "NL"
    }, "NL +31"), m("option", {
      value: "DE"
    }, "DE +49"), m("option", {
      value: "LU"
    }, "LU +352"), m("option", {
      value: "GB"
    }, "GB +44"), m("option", {
      value: "ES"
    }, "ES +34"), m("option", {
      value: "IT"
    }, "IT +39"), m("option", {
      value: "PL"
    }, "PL +48")), m("input", {
      className: "FormControl",
      type: "tel",
      inputmode: "tel",
      autocomplete: "tel",
      bidi: this.phone,
      placeholder: extractText(app.translator.trans('aooci-phone-verification.forum.modal.phone_placeholder')),
      "aria-label": extractText(app.translator.trans('aooci-phone-verification.forum.modal.phone_placeholder')),
      required: true
    })), m("div", {
      className: "Form-group"
    }, m(Button, {
      className: "Button Button--primary Button--block",
      type: "submit",
      loading: this.loading
    }, app.translator.trans('aooci-phone-verification.forum.modal.send_code'))), m("p", {
      className: "helpText PhoneVerificationModal-privacy"
    }, app.translator.trans('aooci-phone-verification.forum.modal.privacy'))];
  }
  codeStep() {
    return [m("p", {
      className: "helpText"
    }, app.translator.trans('aooci-phone-verification.forum.modal.code_help', {
      phone: this.maskedPhone
    })), m("div", {
      className: "Form-group"
    }, m("input", {
      className: "FormControl PhoneVerificationModal-code",
      type: "text",
      inputmode: "numeric",
      autocomplete: "one-time-code",
      maxlength: "6",
      pattern: "[0-9]{6}",
      bidi: this.code,
      placeholder: "123456",
      "aria-label": extractText(app.translator.trans('aooci-phone-verification.forum.modal.code_label')),
      required: true
    })), m("div", {
      className: "Form-group"
    }, m(Button, {
      className: "Button Button--primary Button--block",
      type: "submit",
      loading: this.loading
    }, app.translator.trans('aooci-phone-verification.forum.modal.verify'))), m(Button, {
      className: "Button Button--link",
      type: "button",
      disabled: this.loading,
      onclick: () => this.resetChallenge()
    }, app.translator.trans('aooci-phone-verification.forum.modal.change_number'))];
  }
  onsubmit(event) {
    event.preventDefault();
    if (this.loading) return;
    this.loading = true;
    if (this.challengeId) {
      this.verifyCode();
    } else {
      this.requestCode();
    }
  }
  requestCode() {
    app.request({
      method: 'POST',
      url: app.forum.attribute('apiUrl') + '/aooci/phone/challenges',
      body: {
        phone: this.phone(),
        region: this.region()
      }
    }).then(response => {
      this.challengeId = response.id;
      this.maskedPhone = response.maskedPhone;
      this.loading = false;
      m.redraw();
    }).catch(() => {
      this.loading = false;
      m.redraw();
    });
  }
  verifyCode() {
    app.request({
      method: 'POST',
      url: app.forum.attribute('apiUrl') + '/aooci/phone/challenges/' + encodeURIComponent(this.challengeId || '') + '/verify',
      body: {
        code: this.code()
      }
    }).then(async response => {
      await this.attrs.onVerified({
        mode: this.attrs.mode,
        providerReady: true,
        required: false,
        verified: response.verified,
        maskedPhone: response.maskedPhone
      });
      this.loading = false;
      app.alerts.show({
        type: 'success'
      }, app.translator.trans('aooci-phone-verification.forum.modal.success'));
      this.hide();
    }).catch(() => {
      this.loading = false;
      m.redraw();
    });
  }
  resetChallenge() {
    this.challengeId = null;
    this.maskedPhone = null;
    this.code('');
  }
}
flarum.reg.add('aooci-phone-verification', 'forum/components/PhoneVerificationModal', PhoneVerificationModal);